import { createReducer } from '@reduxjs/toolkit';

import * as actions from './actions';

export const initialState = {
  notifications: {
    data: [],
    employeeNotification: {},
    clientNotification: {},
    sortIds: [],
    isLoading: false,
    isUserLoading: false,
    isUpdateLoading: false,
  },
};

export const notificationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.getNotificationList.start, (state) => {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isLoading: true,
        },
      };
    })
    .addCase(actions.getNotificationList.success, (state, action) => {
      const { data } = action.payload;

      return {
        ...state,
        notifications: {
          ...state.notifications,
          data,
          isLoading: false,
        },
      };
    })
    .addCase(actions.getNotificationList.failure, (state) => ({
      ...state,
      notifications: {
        ...state.notifications,
        isLoading: false,
      },
    }))
    .addCase(actions.getEmployeeNotification.start, (state) => {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isUserLoading: true,
        },
      };
    })
    .addCase(actions.getEmployeeNotification.success, (state, action) => {
      const { data } = action.payload;

      return {
        ...state,
        notifications: {
          ...state.notifications,
          employeeNotification: data,
          isUserLoading: false,
        },
      };
    })
    .addCase(actions.getEmployeeNotification.failure, (state) => ({
      ...state,
      notifications: {
        ...state.notifications,
        isUserLoading: false,
      },
    }))
    .addCase(actions.updateEmployeeNotification.start, (state) => {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isUpdateLoading: true,
        },
      };
    })
    .addCase(actions.updateEmployeeNotification.success, (state) => {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isUpdateLoading: false,
        },
      };
    })
    .addCase(actions.updateEmployeeNotification.failure, (state) => ({
      ...state,
      notifications: {
        ...state.notifications,
        isUpdateLoading: false,
      },
    }))
    .addCase(actions.getCustomerNotification.start, (state) => {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isUserLoading: true,
        },
      };
    })
    .addCase(actions.getCustomerNotification.success, (state, action) => {
      const { data } = action.payload;

      return {
        ...state,
        notifications: {
          ...state.notifications,
          clientNotification: data,
          isUserLoading: false,
        },
      };
    })
    .addCase(actions.getCustomerNotification.failure, (state) => ({
      ...state,
      notifications: {
        ...state.notifications,
        isUserLoading: false,
      },
    }))
    .addCase(actions.updateCustomerNotification.start, (state) => {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isUpdateLoading: true,
        },
      };
    })
    .addCase(actions.updateCustomerNotification.success, (state) => {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isUpdateLoading: false,
        },
      };
    })
    .addCase(actions.updateCustomerNotification.failure, (state) => ({
      ...state,
      notifications: {
        ...state.notifications,
        isUpdateLoading: false,
      },
    }));
});
